import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetTagNFeSaidaResponse } from '@shared/services/responses/repo-dfe/get-tag-nfe-saida.response';
import { GetTagNFeSaidaByIdResponse } from '@shared/services/responses/repo-dfe/get-tag-nfe-saida-by-id.response';
import { CriarTagNFeSaidaResponse } from '@shared/services/responses/repo-dfe/criar-tag-nfe-saida.response';
import { TagNFeSaidaLookupResponse } from '@shared/services/responses/repo-dfe/tag-nfe-saida-lookup.response';
import { TagNFeSaidaRequest } from '@shared/services/requests/repo-dfe/tag-nfe-saida.request';
import { TagNFeSaidaBulkDeleteRequest } from '@shared/services/requests/repo-dfe/tag-nfe-saida-bulk-delete.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagNFeSaidaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiRepoDFe + 'TagNFeSaida';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagNFeSaidaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagNFeSaidaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<GetTagNFeSaidaByIdResponse> {
        const url = `${this.apiUrl}/idTagNFeSaida/${id}`;
        return this.httpClient
            .get<GetTagNFeSaidaByIdResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagNFeSaidaRequest): Observable<CriarTagNFeSaidaResponse> {
        return this.httpClient
            .post<CriarTagNFeSaidaResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagNFeSaidaRequest): Observable<CriarTagNFeSaidaResponse> {
        const url = `${this.apiUrl}/idTagNFeSaida/${id}`;
        return this.httpClient
            .put<CriarTagNFeSaidaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagNFeSaida/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        const request: TagNFeSaidaBulkDeleteRequest = { ids };
        return this.httpClient
            .post<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookup(): Observable<TagNFeSaidaLookupResponse> {
        const url = `${this.apiUrl}/lookup`;
        return this.httpClient
            .get<TagNFeSaidaLookupResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
